/**
 * Navigation actions.
 * @module actions/contextNavigation/contextNavigation
 */

import { GET_CONTEXT_NAVIGATION } from '@plone/volto/constants/ActionTypes';

/**
 * Get the context navigation
 * @function getContextNavigation
 * @param {string} url Content url.
 * @param {params} params Options for the navigation component
 * @returns {Object} Get context navigation action
 */
export function getContextNavigation(url, params = {}) {
  let qs = Object.keys(params)
    .sort()
    .map((key) => `expand.contextnavigation.${key}=${params[key]}`)
    .join('&');
  // `withContentNavigation` monta a chave de leitura no Redux com
  // `pathname.endsWith('/') ? '' : '/'` antes de `@contextnavigation`, mas
  // esta action original não fazia o mesmo — com uma URL terminada em `/`,
  // a action gravava em `state.contextNavigation['.../@contextnavigation']`
  // com barra dupla, enquanto o seletor lia a chave sem barra dupla. Chaves
  // nunca batiam, `navigation` ficava sempre `undefined` e o Menu de
  // Contexto na sidebar renderizava em branco. Normalizando aqui do mesmo
  // jeito que o HOC já faz.
  const path = `${url}${url.endsWith('/') ? '' : '/'}@contextnavigation${qs ? `?${qs}` : ''}`;

  return {
    type: GET_CONTEXT_NAVIGATION,
    url: path, // api middleware strips request
    request: {
      op: 'get',
      path,
    },
  };
}
